import * as d3 from 'd3'

export default {
  methods: {

    draw_Header() {

      let head = this.header
      let col = this.columns
      let ty_ = 0

      let header = this.canvasForms
      .append('g')
      .attr('transform', `translate(0, ${this.funcY})`)

      this.draw_Line(header, 0, head.width, 0, 0, '#757575')
      this.draw_Line(header, 0, head.width, head.height, head.height, '#757575')
      this.draw_Line(header, 0, head.width, this.table.height, this.table.height, '#757575')

      // Depth 1
      ty_ = head.tY[0]
      this.draw_Text(header, '', col[0].mx, head.tY[1]/2+3, head.tSize[0], head.tColor[0], 'middle', col[0].name)
      this.draw_Text(header, '', col[2].mx, ty_,  head.tSize[0], head.tColor[0], 'middle', 'This Week')
      this.draw_Text(header, '', col[4].sx + (head.width-col[4].sx)/2, ty_, head.tSize[0], head.tColor[0], 'middle', 'Cumulative Progress(%)')

      this.draw_Line(header, col[1].sx, head.width, head.depths[1], head.depths[1], '#bcbcbc')
      
      // Depth 2
      ty_ = head.tY[1]
      
      this.draw_Text(header, '', col[1].mx, ty_, head.tSize[1], head.tColor[1], 'middle', 'Plan')
      this.draw_Text(header, '', col[2].mx, ty_, head.tSize[1], head.tColor[1], 'middle', 'Actual')
      this.draw_Text(header, '', col[3].mx, ty_, head.tSize[1], head.tColor[1], 'middle', 'Delta')
      this.draw_Text(header, '', col[4].mx, ty_, head.tSize[1], head.tColor[1], 'middle', 'Plan')
      this.draw_Text(header, '', col[5].mx, ty_, head.tSize[1], head.tColor[1], 'middle', 'Delta')

      // Progress
      this.draw_Text(header, '', (col[6].sx + 5), head.height - 6, 8, '#bcbcbc', 'middle', 0)
      this.draw_Text(header, '', (col[6].sx + col[6].width/2), head.height - 6, 8, '#bcbcbc', 'middle', 50)
      this.draw_Text(header, '', (col[6].ex - 5), head.height - 6, 8, '#bcbcbc', 'middle', 100)

      this.draw_Line(header, col[0].ex, col[0].ex, 0, this.table.height, '#bcbcbc')
      this.draw_Line(header, col[3].ex, col[3].ex, 0, this.table.height, '#bcbcbc')

      this.draw_Line(header, col[1].ex, col[1].ex, head.depths[1], this.table.height, '#E0E0DF')
      this.draw_Line(header, col[2].ex, col[2].ex, head.depths[1], this.table.height, '#E0E0DF')
      this.draw_Line(header, col[4].ex, col[4].ex, head.depths[1], this.table.height, '#E0E0DF')
      this.draw_Line(header, col[5].ex, col[5].ex, head.depths[1], this.table.height, '#E0E0DF')
    },

    
  }
}